
export const COLOR_PRIMARY = '#01065A';
export const COLOR_SECONDARY = '#CD8906';
export const COLOR_INACTIVE = '#dbdbdb';
export const COLOR_BACKGROUND = '#FAFAFA';
